module.exports = __webpack_public_path__ + "img/Machine4.36b85040.svg";